import React from "react";
import { useLocation } from "react-router-dom";
import Category from "components/Category";
import { SupplierFeedbackRow, SupplierFeedbackListProps } from "./SupplierFeedbackList.types";
import { useSupplierFeedbackCategoryProps } from "./SupplierFeedbackList.hooks";

const SupplierFeedback: React.FC<SupplierFeedbackListProps> = (props) => {
  const location = useLocation();
  const categoryProps = useSupplierFeedbackCategoryProps(props, location);

  return (
    <div className="SupplierFeedbackPage CardListPage">
      <Category<SupplierFeedbackRow> {...categoryProps} />
    </div>
  );
};

export default SupplierFeedback;
